import { Lightbox } from '@3pc/lightbox-photoswipe';
import {
  config,
  fixCounter,
  addZoomIcons,
} from '../../0-atoms/lightbox/lightbox';

const galleryEl = document.querySelectorAll(
  '.textmedia__image.click-redirect-parent'
);
export const lightboxInstances = [];
const ecoModeIsActive = localStorage.getItem('eco-mode-active') === 'true';

galleryEl.forEach(gallery => {
  const children = gallery.querySelectorAll('.textmedia__lightbox-toggle');
  if (!ecoModeIsActive) {
    config.arrowNextSVG = '';
    config.arrowPrevSVG = '';

    const lightbox = new Lightbox({ ...{ gallery, children }, ...config });

    lightbox.init();
    fixCounter(lightbox);
    addZoomIcons(lightbox);
    lightboxInstances.push(lightbox);
    children.forEach(toggle => {
      if (toggle.disabled) toggle.removeAttribute('disabled');
    });
  } else {
    children.forEach(toggle => {
      toggle.disabled = true;
    });
  }
});
